<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue';
export default {
  name: 'About',
  components: {Bigmenu},
  data () {
    return {

      show:false,
      show2:false
    }
  },
  methods:{
    test(){
      this.show = false;
    }
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC');
  @font-face {
    font-family: 'SH Bree Headline';
    src: url('~@/assets/font/SH-Bree-HeadlineEUR.woff2') format('woff2');
    font-display: swap;
  }
  @font-face {
    /* 全站英數字型：unicode-range 限定拉丁字集，中文自動落到 Noto Sans TC */
    font-family: MyCustomFont;
    unicode-range:  U+00-024F; /* ASCII */
    src: url('~@/assets/font/SH-Bree-HeadlineEUR.woff2') format('woff2'),
         local(Helvetica Neue), local(Arial); /* 字型載入失敗時的備援 */
    font-display: swap;
  }
  html,body{
    font-family:'MyCustomFont','Noto Sans TC';
    padding: 0;
    margin: 0;
    -webkit-text-size-adjust: none;
  }
  /* 觸控機用：關掉游標閃爍、點擊反白、選取反白與 focus 外框 */
  * {
    caret-color: transparent;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  *:focus,
  *:focus-visible {
    outline: none;
  }
  /* 內頁（首頁以外）統一黑底；首頁沒有 .Subpage，不受影響 */
  .Subpage {
    background-color: #000;
  }

  body::-webkit-scrollbar {
    display: none;

  }
#app {

  font-family:'MyCustomFont','Noto Sans TC';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  width: 1920px;
  height: 1080px;
  font-weight: 400;
  /*background-color: aqua;*/
  /*overflow: no-display;*/
  /*overflow: hidden;*/
  /*overflow: scroll;*/
}



</style>
